import React from 'react';
import { useParams } from 'react-router-dom';

function Index(props) {
    const { slug } = useParams();
    return (
        <>
            <div className="container">
                <h1>Title</h1>
                <div className="page-content">
                    {slug}
                </div>
            </div>
        </>
    );
}

export default Index;